module.exports = __webpack_public_path__ + "static/img/seller-badge.91f3fbd0.svg";